module.exports = __webpack_public_path__ + "static/img/15011452161.27379e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15011452161.png
// module id = 4tPB
// module chunks = 0